import React from 'react';
import ReactDOM from 'react-dom'
import dayjs from 'dayjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import PDFObject from 'pdfobject';

var advancedFormat = require('dayjs/plugin/advancedFormat')
dayjs.extend(advancedFormat);

import './Certificate.scss';

class Certificate extends React.Component {
  logoLoaded = false
  bgLoaded = false
  renderPDF = (src) => {
    this[src] = true;

    if (this.logoLoaded && this.bgLoaded) {
      const input = document.getElementById('certificate');

      html2canvas(input, {scale: 1})
        .then((canvas) => {
          const pdf = new jsPDF({
            orientation: 'landscape',
            format: 'letter'
          });

          pdf.addImage(canvas, 0, 0);
          const datauri = pdf.output('bloburi', {filename: 'certificate.pdf'});
          PDFObject.embed(datauri, '#pdfpreview');
        });
    }
  }
  render() {
    const { profile, enrollable, enrollment } = this.props;
    return (
      <div className='position-relative bg-white boxshadowLight p-5 mx-auto' id="certificate" style={{width: '279.4mm', height: '215.9mm'}}>
        <img src="/certificate_resources/certificate_background_3.jpg" className='background' onLoad={() => this.renderPDF('bgLoaded')}/>
        <div className='info'>
          <div className="mb-5">
            <img className='alt-logo' src="/certificate_resources/altcademy-blue-on-transparent.png" onLoad={() => this.renderPDF('logoLoaded')} />
          </div>
          <p className="pt-3 mb-4"><small>{dayjs(enrollment.attributes.graduated_date).format('MMMM Do, YYYY')}</small></p>
          <h1 className="mb-3">{`${profile.first_name} ${profile.last_name || ''}`}</h1>
          <p className="mb-3"><small>has successfully completed</small></p>
          <h3 className="mb-3">{enrollable.long_name}</h3>
          <p className="mb-5"><small>an online non-credit program offered by Altcademy.com</small></p>

          <div className='signatures pt-5 mb-3'>
            <div className="d-inline-block mr-4">
              <p className='name1 text-center'>HarryChen</p>
              <div className='line' />
              <div className='details'><small className="text-secondary">Harry Chen, BAS</small></div>
              <div className='details'><small className="text-secondary">Instructor</small></div>
            </div>
            <div className=" d-inline-block">
              <p className='name2 text-center'>XiaoYang</p>
              <div className='line' />
              <div className='details'><small className="text-secondary">Xiao Yang, MENG</small></div>
              <div className='details'><small className="text-secondary">Instructor</small></div>
            </div>
          </div>
          <div className="text-right text-secondary">
            <p><small>Verify at altcademy.com/@{profile.username}/verify/{enrollable.long_symbol}</small></p>
          </div>
        </div>
      </div>
    );
  }
}

export default Certificate;
